export function setNetworkStatus(status) {
  return {
    type: 'SET_NETWORK_STATUS',
    status
  };
}
